import { useParams, useSearchParams } from "helpers/tixxt-router";
import { Filter } from "components/directory/types";

export default function useDirectoryFilter(): {
  filter: Filter;
  currentPage: string;
} {
  const [searchParams] = useSearchParams();
  const { groupSlug } = useParams();

  const currentPage = searchParams.get("page") || "1";
  const filter = {};

  searchParams.forEach((value, key) => (filter[key] = value));
  if (groupSlug) filter["groupSlug"] = groupSlug;

  return { filter, currentPage };
}
